function SharedCartPage() {
    let checkoutURL;
    let totalCartCost;
    let CartCurrencyCode;
    let cartItems;
    const debug = false;
    this.log = (message, data)=> {
        if(debug === true) console.log("CartPage: " + message, data)
    }
    this.setCartItems = (_cartItems)=> {
        cartItems = _cartItems;
    }
    this.addItem = async (item) => {
        console.log('addItem',item);
        try {

            if (document.getElementById(`CartItem-${item.node.id}`)) {
                this.log('item already in cart. updating it')
                await this.updateItem(item);
                //document.getElementById(`CartItem-${item.node.id}`).remove();
            }else{
                this.log('its a new item')
                await this.lineItemDomElement(item);
            }
            await this.updateCheckoutPriceAndCartIconCount();
            new theme.AddOnDisplay();
        } catch (error) {
            console.log(error);
        }
    }
    this.refreshItems = async () => {
        let globalCartsItems = cartItems?.cart?.lines?.edges;
        await globalCartsItems.map(async (item, index) => {
            await this.addItem(item);
        });
        await this.toggleVisualElements();
    }
    this.init = async ()=>{

        let globalCartsItems = cartItems?.cart?.lines?.edges;
        globalCartsItems && globalCartsItems.map(async (item, index) => {
            await this.addItem(item);
        });
        await this.toggleVisualElements();
        new theme.AddOnDisplay();
    }
    this.toggleVisualElements = async ()=> {
        await this.updateCheckoutPriceAndCartIconCount();
        const cartItemNodes = document.querySelectorAll('cart-items tr.cart-item')

        this.log('cartItemLength', cartItemNodes.length);
        if (cartItemNodes.length === 1) {
            //cart is empty
            document.getElementsByTagName('cart-items')[0].classList.add('is-empty');
            document.getElementById('main-cart-footer').classList.add('is-empty');

        }else{
            //cart has items
            document.getElementsByTagName('cart-items')[0].classList.remove('is-empty');
            document.getElementById('main-cart-footer').classList.remove('is-empty');

        }
    }
    this.updateCheckoutButton = () => {
        document.getElementById("checkout").innerText =
            "CHECKOUT $" + totalCartCost;
        document.getElementById("checkout").removeAttribute('disabled');

        document.getElementsByClassName(
            "totals__subtotal-value"
        )[0].innerText =
            "$" +
            totalCartCost +
            " " +
            cartItems?.cart?.estimatedCost?.subtotalAmount?.currencyCode;

    }
    this.checkoutButtonClickListener = (e) => {
        try {
            let note = '';
            const cartNoteElement = document.querySelector('cart-drawer cart-note > textarea');
            if (cartNoteElement) {
                //check if element has notes, send it to shopify to update the cart with note
                if(cartNoteElement.value.length){
                    note = cartNoteElement.value;
                }
            }
            e.preventDefault();
            e.stopPropagation();
            this.log('checkout from cart page');
            document.documentElement.dispatchEvent(new CustomEvent('checkout:clicked',
                {
                    bubbles: true,
                    detail: {
                        checkoutUrl: checkoutURL,
                        note: note
                    }
                }));

        } catch (error) {
            console.log(error);
        }
    }
    this.updateCheckoutPriceAndCartIconCount = async () => {
        try {
            checkoutURL = cartItems?.cart?.checkoutUrl || "/";
            totalCartCost = parseFloat(
                cartItems?.cart?.estimatedCost?.subtotalAmount?.amount
            ).toFixed(2);
            CartCurrencyCode =
                cartItems?.cart?.estimatedCost?.subtotalAmount?.currencyCode;
            const checkout_button = document.getElementById("checkout");
            if (checkout_button) {
                checkout_button.removeEventListener('click', this.checkoutButtonClickListener);
                checkout_button.addEventListener("click", this.checkoutButtonClickListener);
            }

            this.updateCheckoutButton(`${totalCartCost} ${CartCurrencyCode}`);

        } catch (error) {
            console.log(error);
        }
    }
    this.createListPropertiesDomElement = (attributes, lineItemDomElement) => {
        console.log(attributes);
        try {
            const properties = lineItemDomElement.querySelector(
                ".cart-item__details"
            );
            attributes.forEach((attribute) => {
                if (!attribute?.key || attribute.key.startsWith('_')) {
                    return false;
                }
                let LiDomElement = document.createElement("div");
                let dt = document.createElement('dt');
                dt.innerHTML = attribute?.key + ": ";
                let dd = document.createElement('dd');
                dd.innerHTML = attribute?.value;

                LiDomElement.classList.add('product-option');
                LiDomElement.append(dt);
                LiDomElement.append(dd);
                properties.appendChild(LiDomElement);

            });

        } catch (error) {
            console.log(error);
        }
    }
    this.removeItem = async (item) => {
        const lineItem = document.getElementById(`CartItem-${item.node.id}`);
        if (lineItem) {
            lineItem.remove();
            this.log('line item removed');
          new theme.AddOnDisplay();
            //await this.toggleVisualElements();
        }
    }
    this.updateItem = async (item) => {
        const lineItem = document.getElementById(`CartItem-${item.node.id}`);
        if (lineItem) {
            this.log('line item found', lineItem)
            lineItem.querySelector('.loading-overlay').classList.add('hidden');
            const item_subtotalAmount = parseFloat(item.node.cost.subtotalAmount.amount);
            const item_total_amount = parseFloat(item.node.cost.totalAmount.amount);
            const discounted_item_amount = parseFloat(item.node.cost.totalAmount.amount)/parseFloat(item.node.quantity);
            const item_Amount = parseFloat(item.node.cost.amountPerQuantity.amount);
            const itsDiscountedProduct = item_subtotalAmount > item_total_amount;
            const priceLable = lineItem.querySelectorAll(".price");

            priceLable[0].innerHTML = itsDiscountedProduct
                ? `<p style="color:#8c8c8c"><strike>$${item_Amount}</strike></p>` + " $" + parseFloat(discounted_item_amount).toFixed(2)
                : "$" + parseFloat(item_Amount).toFixed(2);
            priceLable[1].innerHTML = itsDiscountedProduct
                ? `<p style="color:#8c8c8c"><strike>$${item_subtotalAmount}</strike></p>` + " $" + parseFloat(item_total_amount).toFixed(2)
                : "$" + parseFloat(item_subtotalAmount).toFixed(2);
            priceLable[2].innerHTML = itsDiscountedProduct
                ? `<p style="color:#8c8c8c"><strike>$${item_subtotalAmount}</strike></p>` + " $" + parseFloat(item_total_amount).toFixed(2)
                : "$" + parseFloat(item_subtotalAmount).toFixed(2);
            const quantity_selector__input = lineItem.querySelector(
                ".quantity__input"
            );

            quantity_selector__input.value = item.node.quantity;


        }else{
            await this.addItem(item)
        }
      new theme.AddOnDisplay();
    }
    /**
     * Execute a function given a delay time
     *
     * @param {type} func
     * @param {type} wait
     * @param {type} immediate
     * @returns {Function}
     */
    this.debounce =  (func, wait, immediate) => {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };
    this.lineItemDomElement = async (item) => {
        try {
            this.log('item',item);
            if (item.node.quantity === 0) return
            const vendor_map = {
                'Wolf Athletics' : 'https://wolf-athletics.com/',
                'Epoch Lacrosse' : 'https://epochlacrosse.com/',
                'SNYPR' : 'https://snypr.com/',
                'Lacrosse Playground' : 'https://lacrosseplayground.com/',
            };
            let store_url = 'https://epochlacrosse.com/';
            if(vendor_map[item.node.merchandise.product.vendor]){
                store_url = vendor_map[item.node.merchandise.product.vendor];
            }
            const item_subtotalAmount = parseFloat(item.node.cost.subtotalAmount.amount);
            const item_total_amount = parseFloat(item.node.cost.totalAmount.amount);

            const discounted_item_amount = parseFloat(item.node.cost.totalAmount.amount)/parseFloat(item.node.quantity);
            const item_Amount = parseFloat(item.node.cost.amountPerQuantity.amount);
            const item_link = store_url + 'products/' + item.node.merchandise.product.handle;


            const itsBundleProduct = item_subtotalAmount === "0.0";
            const itsDiscountedProduct = item_subtotalAmount > item_total_amount;
            /*const CartIcon = document.getElementsByTagName("cart-count");
            CartIcon[0].innerText = CartIcon_quantity;*/
            const lineItem = document
                .getElementById("line-item_copy")
                .cloneNode(true);

            lineItem.id = `CartItem-${item.node.id}`;
            lineItem.dataset.variant = item.node.merchandise.id;
            lineItem.style.display = "";
            lineItem.querySelector(".line-item__image").src =
                item?.node?.merchandise?.image?.url ||
                "https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-100-c91dd4bdb56513f2cbf4fc15436ca35e9d4ecd014546c8d421b1aece861dfecf_92x.gif";
            const lineItem_title = lineItem.querySelectorAll(
                ".product-item-meta__title"
            );
            lineItem_title[0].innerText = item.node.merchandise.product.title;
            lineItem.querySelector('.cart-item__name').setAttribute('href', item_link)
            // if this item is custom product
            if (item.node.attributes.length > 1) {
                const attributes_and_options = item.node.attributes.concat(
                    item.node.merchandise.selectedOptions
                );
                this.createListPropertiesDomElement(attributes_and_options, lineItem);
            } else {
                if (lineItem.querySelector(".vendor-name")) {
                    lineItem.querySelector(".vendor-name").innerText =
                        item.node.merchandise.product.vendor;
                    lineItem.querySelector(".vendor-name").style.display = 'block';
                }

                // lineItem.querySelector("#line_item_properties").innerText =
                let productOtionsDomElement = document.createElement("P");

                const productOtions = item.node.merchandise.selectedOptions
                    .map((option) => {
                        return option.value;
                    })
                    .join(" / ");

                productOtionsDomElement.innerText = productOtions;

                lineItem
                    .querySelector(".cart-item__details")
                    .appendChild(productOtionsDomElement);
                this.createListPropertiesDomElement(item.node.attributes, lineItem);
            }
            const priceLable = lineItem.querySelectorAll(".price");
            this.log('priceLable', priceLable);

            priceLable[0].innerHTML = itsDiscountedProduct
                ? `<p style="color:#8c8c8c"><strike>$${item_Amount}</strike></p>` + " $" + parseFloat(discounted_item_amount).toFixed(2)
                : "$" + parseFloat(item_Amount).toFixed(2);
            priceLable[1].innerHTML = itsDiscountedProduct
                ? `<p style="color:#8c8c8c"><strike>$${item_subtotalAmount}</strike></p>` + " $" + parseFloat(item_total_amount).toFixed(2)
                : "$" + parseFloat(item_subtotalAmount).toFixed(2);
            priceLable[2].innerHTML = itsDiscountedProduct
                ? `<p style="color:#8c8c8c"><strike>$${item_subtotalAmount}</strike></p>` + " $" + parseFloat(item_total_amount).toFixed(2)
                : "$" + parseFloat(item_subtotalAmount).toFixed(2);


            /*priceLable[0].innerHTML = itsDiscountedProduct
                ? `<p style="color:#8c8c8c;margin-top: 0"><strike>$${item_Amount}</strike></p>` + " $" + parseFloat(item_total_amount).toFixed(2)
                : "$" + parseFloat(item_Amount).toFixed(2);
            priceLable[1].innerHTML = itsDiscountedProduct
                ? `<p style="color:#8c8c8c;margin-top: 0"><strike>$${item_Amount}</strike></p>` + " $" + parseFloat(item_total_amount).toFixed(2)
                : "$" + parseFloat(item_subtotalAmount).toFixed(2);
            priceLable[2].innerHTML =itsDiscountedProduct
                ? `<p style="color:#8c8c8c;margin-top: 0"><strike>$${item_Amount}</strike></p>` + " $" + parseFloat(item_total_amount).toFixed(2)
                : "$" + parseFloat(item_subtotalAmount).toFixed(2);*/

            const quantity_selector__input = lineItem.querySelector(
                ".quantity__input"
            );
            quantity_selector__input.addEventListener("keyup", this.debounce(async (e)=> {
                e.preventDefault();
                if(parseInt(quantity_selector__input.value) === 0) return false;
                lineItem.querySelector('.loading-overlay').classList.remove('hidden');
                document.documentElement.dispatchEvent(
                    new CustomEvent("variant:updated", {
                        bubbles: true,
                        detail: {
                            lineItem: lineItem,
                            id: item?.node?.id,
                            quantity: parseInt(quantity_selector__input.value) ,
                            quantityToUpdate: parseInt(quantity_selector__input.value),
                            handle: item?.node?.merchandise?.product?.handle,
                            attributes: item?.node?.attributes,
                        },
                    })
                );
            },500));
            quantity_selector__input.value = item.node.quantity;

            if (document.getElementById("drawer__content-footer_example")) {
                document.getElementById(
                    "drawer__content-footer_example"
                ).style.display = "block";
            }


            // minus

            quantity_selector__input.previousElementSibling.addEventListener(
                "click",
                async () => {
                    if(parseInt(quantity_selector__input.value) === 1) return false;
                    lineItem.querySelector('.loading-overlay').classList.remove('hidden');
                    this.log('loading element',lineItem.querySelector('.loading-overlay').classList)
                    document.documentElement.dispatchEvent(
                        new CustomEvent("variant:updated", {
                            bubbles: true,
                            detail: {
                                lineItem: lineItem,
                                id: item?.node?.id,
                                quantity: parseInt(quantity_selector__input.value) - 1,
                                quantityToUpdate: -1,
                                handle: item?.node?.merchandise?.product?.handle,
                                attributes: item?.node?.attributes,
                            },
                        })
                    );
                }
            );

            //plus
            quantity_selector__input?.nextElementSibling.addEventListener(
                "click",
                async () => {
                    lineItem.querySelector('.loading-overlay').classList.remove('hidden');
                    document.documentElement.dispatchEvent(
                        new CustomEvent("variant:updated", {
                            bubbles: true,
                            detail: {
                                lineItem: lineItem,
                                id: item.node.id,
                                quantity: parseInt(quantity_selector__input.value)  + 1,
                                quantityToUpdate: 1,
                                handle: item?.node?.merchandise?.product?.handle,
                                attributes: item.node.attributes,
                            },
                        })
                    );
                }
            );

            // remove item
            lineItem
                .querySelector(".line-item__remove-button")
                .addEventListener("click", async () => {
                    lineItem.querySelector('.loading-overlay').classList.remove('hidden');
                    document.documentElement.dispatchEvent(
                        new CustomEvent("variant:updated", {
                            bubbles: true,
                            detail: {
                                lineItem: lineItem,
                                id: item.node.id,
                                quantity: 0,
                                quantityToUpdate: -1 * parseInt(quantity_selector__input.value) ,
                                handle: item?.node?.merchandise?.product?.handle,
                                attributes: item.node.attributes,
                            },
                        })
                    );
                });

            itsBundleProduct &&
            (lineItem.querySelector(".line-item__remove-button").style.display =
                "none");

            const mini_cart_form = document.getElementById("mini-cart-form");
            mini_cart_form.appendChild(lineItem);
     } catch (error) {
            console.log(error);
        }
    }
}
